module.exports = __webpack_public_path__ + "img/buy.57f412e3.png";